import React from 'react';
import { NovaContextProvider } from './NovaContextProvider';

export function wrapInNovaProvider(component: JSX.Element): JSX.Element {
    return <NovaContextProvider>{component}</NovaContextProvider>;
}
